import httpBuildQuery from '../../../procedures/http-build-query';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/amqp/queues`;

export default {
  index: async (query) => await axios.get(baseUri + httpBuildQuery(query)),
};
